/* import __COLOCATED_TEMPLATE__ from './selected-posts.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./selected-posts.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({}));